import { type useIntl } from 'react-intl';
import { PriceSummaryDiscountItem } from '../types';

type FormatMessage = ReturnType<typeof useIntl>['formatMessage'];

export const getSavingsItemTitle = (
  item: PriceSummaryDiscountItem,
  { formatMessage }: { formatMessage: FormatMessage }
): string => {
  if (item.type === 'offer') {
    return formatMessage({ id: 'cart:savings:offer' });
  }

  if (item.type === 'subscription') {
    return formatMessage({ id: 'cart:savings:subscription' });
  }

  if (item.type === 'referal') {
    return formatMessage({ id: 'cart:savings:referal' });
  }

  if (item.type === 'coupon') {
    return formatMessage({ id: 'cart:savings:coupon' }, { couponCode: item.couponCode });
  }

  if (item.type === 'savings_plan') {
    return item.planName
      ? formatMessage({ id: `cart:savings:offer:savings-plan:${item.planName}` })
      : formatMessage({ id: 'cart:savings:yearly-savings-by-plan' }, { planName: '' });
  }

  if (item.type === 'dynamic_bundle') {
    return formatMessage({ id: 'dynamic-bundle:personal-box:default-title' });
  }

  console.error(`Unknown discount type: ${item.type}`);
  return '';
};
